import {WatchService} from "../watch.service";
import {JP} from "../../helpers/jp";
export class BaseUtils {
  constructor(private watchService: WatchService) {
  }


  protected notify() {
    this.watchService.notify();
  }


  protected pushTo(document: any,
                   prop: string,
                   newItem: any): void {
    const container: any[] = document[prop];
    container.push(newItem);
    this.notify();
  }


  protected push(document: any,
                 pointer: string,
                 newItem: any) {
    JP.set(document, `${pointer}/-`, newItem);
    this.notify();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/factory-service-impl/base.utils.ts